/** @format */
import { ChangeDetectionStrategy, Component, Inject, inject, ViewEncapsulation, DOCUMENT } from '@angular/core';
import { MAT_DIALOG_DATA } from '@angular/material/dialog';
import { FudisDialogService } from '@funidata/ngx-fudis';

export interface SystemErrorModalFdValues {
    title: string;
    message?: string;
    errorCode?: number;
    errorDetails?: string;
    stacktrace?: string;
    userAgent?: string;
}

export function systemErrorModalFdOpener() {
    const fudisDialogService = inject(FudisDialogService);
    return (values: SystemErrorModalFdValues) => fudisDialogService.open(SystemErrorModalFdComponent, { data: values });
}

@Component({
    selector: 'sis-system-error-modal-fd',
    templateUrl: './system-error-modal-fd.component.html',
    encapsulation: ViewEncapsulation.None,
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: false,
})
export class SystemErrorModalFdComponent {
    readonly errorInfo: string;

    constructor(
        @Inject(MAT_DIALOG_DATA) protected values: SystemErrorModalFdValues,
        @Inject(DOCUMENT) private document: Document,
    ) {
        this.errorInfo = `\
DETAILS:
${values.errorDetails ?? '-'}

ERROR CODE:
${values.errorCode ?? '-'}

STRING:
${values.userAgent ?? '-'}

STACKTRACE:
${values.stacktrace ?? '-'}`;
    }

    refreshPage(): void {
        this.document.location.reload();
    }
}
